import * as React from "react";
import { useState } from "react";
import { Typography, TextField, Button, Box, IconButton, InputAdornment } from "@mui/material";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import { NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import accountApi from "../app/AccountApi";
import AvatarBox from "./AvatarBox";
import session from "../app/Session";
import routes from "./routes";
import { UnauthorizedError } from "../app/errors";
import { fadeReload } from "../app/transition";
import { subscribeTopic } from "./SubscribeDialog"; // ADD THIS
import subscriptionManager from "../app/SubscriptionManager"; // ADD THIS
import poller from "../app/Poller"; // ADD THIS

// Odoo API config
const ODOO_API_URL = "https://school.mefobe.net/ntfy/topic"; // Your Odoo endpoint
const ODOO_API_KEY = "your-odoo-api-key"; // Or better: inject via build env

const Login = () => {
  const { t } = useTranslation();
  const [error, setError] = useState("");
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    const user = { username, password };
    try {
      const { token, username: canonicalUsername } = await accountApi.login(user);
      console.log(`[Login] User auth for user ${user.username} successful, logged in as ${canonicalUsername}`);
      await session.store(canonicalUsername, token);
      
      // --- AUTO-SUBSCRIBE FROM ODOO ---
      await autoSubscribeFromOdoo(canonicalUsername);
      // ---------------------------------
      
      fadeReload(routes.app);
    } catch (e) {
      console.log(`[Login] User auth for user ${user.username} failed`, e);
      if (e instanceof UnauthorizedError) {
        setError(t("Login failed: Invalid username/email or password"));
      } else {
        setError(e.message);
      }
    }
  };

  // Fetch topic from Odoo and auto-subscribe
  const autoSubscribeFromOdoo = async (canonicalUsername) => {
    try {
      const response = await fetch(`${ODOO_API_URL}?username=${encodeURIComponent(canonicalUsername)}`, {
        method: "GET",
        headers: {
          "Authorization": `Bearer ${ODOO_API_KEY}`,
        },
      });
      
      if (!response.ok) {
        console.log("[Login] Odoo topic fetch failed", response.status);
        return;
      }
      
      const data = await response.json();
      if (!data.topic) {
        console.log("[Login] No topic assigned for user", canonicalUsername);
        return;
      }
      
      const topic = data.topic;
      console.log(`[Login] Auto-subscribing to Odoo topic: ${topic}`);
      
      // Subscribe to topic on the local ntfy server
      const subscription = await subscribeTopic(config.base_url, topic, {});
      
      // Start polling for messages
      poller.pollInBackground(subscription);
      
      console.log(`[Login] Successfully auto-subscribed to ${topic}`);
    } catch (e) {
      console.log("[Login] Auto-subscribe error", e);
      // Don't block login on auto-subscribe failure
    }
  };

  if (!config.enable_login) {
    return (
      <AvatarBox>
        <Typography sx={{ typography: "h6" }}>{t("login_disabled")}</Typography>
      </AvatarBox>
    );
  }
  return (
    <AvatarBox>
  <Box sx={{ textAlign: 'center', mb: 3 }}>
    <Typography variant="h4" sx={{ fontWeight: 700, color: '#1a5f7a', mb: 1 }}>
      🔐 Espace Parents
    </Typography>
    <Typography variant="body2" sx={{ color: '#64748b' }}>
      Connectez-vous avec vos identifiants fournis par l'école
    </Typography>
  </Box>
  
  <TextField
    fullWidth
    label="Identifiant parent"
    placeholder="ex: parent.dupont"
    value={username}
    onChange={(e) => setUsername(e.target.value)}
    sx={{ mb: 2, '& .MuiOutlinedInput-root': { borderRadius: 3 } }}
  />
  
  <TextField
    fullWidth
    type="password"
    label="Mot de passe"
    value={password}
    onChange={(e) => setPassword(e.target.value)}
    sx={{ mb: 3, '& .MuiOutlinedInput-root': { borderRadius: 3 } }}
  />
  
  <Button 
    fullWidth 
    variant="contained" 
    size="large"
    onClick={handleSubmit}
    sx={{ 
      bgcolor: '#1a5f7a', 
      borderRadius: 3, 
      py: 1.5,
      fontSize: '16px',
      textTransform: 'none'
    }}
  >
    Se connecter
  </Button>
  
  {error && (
    <Alert severity="error" sx={{ mt: 2, borderRadius: 2 }}>
      {error}
    </Alert>
  )}
</AvatarBox>
  );
};

export default Login;
